


















import { defineComponent, toRefs, computed, ref } from '@vue/composition-api';
export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    defaultRole: {
      type: Number,
      default: 0,
    },
    users: {
      type: Array,
      default: [],
    },
  },
  setup(props, context) {
    const { users } = toRefs(props);
    const store = context.root.$store;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });

    // eslint-disable-next-line max-len
    const roleId = ref(
      users.value[0] ? (users.value as CoFile.TeamMember[])[0].teamRoleId : store.getters.roles[0]?.id,
    );
    const methods = {
      confirm() {
        const authority = users.value.map(item =>
          Object.assign(item, {
            roleId: +roleId.value,
          }),
        );
        context.emit('submit', authority);
      },
    };
    return {
      innerShow,
      roleId,
      ...methods,
    };
  },
});
